export const Sizes = {
  leftBar: 70,
  topBar: 77,
  drawerInputLabelWidth: 140,
  unitDetailsInputLabelWidth: 120,
  datePickerWidth: 160,
  labelMatchWithWidth: 150
};
